module.exports = __webpack_public_path__ + "img/phone.84cda38d.png";